export default __webpack_public_path__ + "static/media/ST.d4a63b42.svg";